import { convertDatesToISO, getHeaders } from '@/config/aux'
import { FtpSettings } from '../models/ftpSettings'
import { FtpSettingsStateType } from './state'
import axios from 'axios'

export interface FtpSettingsActionsType {
  getFtpSettings(): Promise<void>
  getFtpSettingsByHost(host: string): Promise<void>
  postFtpSettings(ftpSettings: FtpSettings): Promise<void>
  putFtpSettings(ftpSettings: FtpSettings): Promise<void>
  deleteFtpSettings(id: string): Promise<void>
}

export const FtpSettingsActions = {
  async getFtpSettings(this: FtpSettingsStateType) {
    try {
      this.ftpSettings = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/ftp-settings`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((ftpSetting: FtpSettings) => {
            this.ftpSettings.push(ftpSetting)
          })
        }
      })
    } catch (error) {
      console.error('Error getting FtpSettings', error)
    }
  },
  async getFtpSettingsByHost(this: FtpSettingsStateType, host: string) {
    try {
      this.ftpSetting = null
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/ftp-settings/host/${host}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          this.ftpSetting = response.data
        }
      })
    } catch (error) {
      console.error('Error getting FtpSettings by host', error)
    }
  },
  async postFtpSettings(this: FtpSettingsStateType, ftpSettings: FtpSettings) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/ftp-settings`
      const data = convertDatesToISO(ftpSettings.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.ftpSettings.push(ftpSettings)
        }
      })
    } catch (error) {
      console.error('Error posting FtpSettings', error)
    }
  },
  async putFtpSettings(this: FtpSettingsStateType, ftpSettings: FtpSettings) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/ftp-settings`
      const data = convertDatesToISO(ftpSettings.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.ftpSettings = this.ftpSettings.map(s => (s.id === ftpSettings.id ? ftpSettings : s))
          }
        })
    } catch (error) {
      console.error('Error updating FtpSettings', error)
    }
  },
  async deleteFtpSettings(this: FtpSettingsStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/ftp-settings/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.ftpSettings = this.ftpSettings.filter(s => s.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting FtpSettings', error)
    }
  },
}
